import { dataGateway } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGateway = /*#__PURE__*/createIcon(dataGateway)
export default IconGateway
